import { Action } from '@ngrx/store';
import { IClient } from "../../models/client.model";

export const GET_CLIENT = '[client] get client';
export const GET_CLIENT_SUCCESS = '[client] get client success';
export const GET_CLIENT_FAILED = '[client] get client failed';

export class GetClient implements Action {
  public readonly type = GET_CLIENT;
  public constructor() { }
}

export class GetClientSuccess implements Action {
  public readonly type = GET_CLIENT_SUCCESS;
  public constructor(public payload: IClient) { }
}

export class GetClientFailed implements Action {
  public readonly type = GET_CLIENT_FAILED;
  public constructor(public payload: any) { }
}


export type All
  = GetClient
  | GetClientSuccess
  | GetClientFailed;



// WEBPACK FOOTER //
// ./src/ngrx/actions/client.actions.ts